import type { TermsTranslations } from '../en-US/terms.translations';

export const termsTranslations: TermsTranslations = {
  title: 'Termini e Condizioni',
  lastUpdated: 'Ultimo aggiornamento: 7 marzo 2025',
  sections: {
    introduction: {
      title: 'Introduzione',
      content:
        'Benvenuto su BiteCritic! Questi Termini e Condizioni regolano il tuo utilizzo della nostra piattaforma e dei nostri servizi. Utilizzando BiteCritic, accetti integralmente questi termini.',
    },
    userAgreement: {
      title: 'Accordo Utente',
      content: 'Creando un account su BiteCritic, accetti di:',
      items: [
        'Fornire informazioni accurate e veritiere',
        'Mantenere la sicurezza del tuo account',
        'Assumerti la responsabilità di tutte le attività sotto il tuo account',
        'Rispettare tutte le leggi e i regolamenti applicabili',
      ],
    },
    content: {
      title: 'Linee Guida sui Contenuti',
      content: 'Utilizzando BiteCritic, accetti di:',
      items: [
        'Condividere recensioni autentiche e oneste',
        'Rispettare i diritti di proprietà intellettuale',
        'Non pubblicare contenuti dannosi, offensivi o inappropriati',
        'Non impegnarti in spam o comportamenti ingannevoli',
      ],
    },
    contentRights: {
      title: 'Diritti sui Contenuti e Conservazione',
      content: 'Riguardo ai tuoi contenuti su BiteCritic:',
      items: [
        'Mantieni la proprietà dei tuoi contenuti, ma ci concedi una licenza mondiale, non esclusiva e gratuita per utilizzare, visualizzare, distribuire, riprodurre, modificare e creare opere derivate dai tuoi contenuti in relazione al Servizio e per scopi promozionali e di marketing di BiteCritic, incluso, ma non limitato a, la visualizzazione sul nostro sito web, app e piattaforme di terze parti come i social media',
        'Quando elimini il tuo account, le tue informazioni personali verranno anonimizzate, ma le tue recensioni e altri contenuti contribuiti potrebbero essere conservati',
        'I contenuti appariranno come pubblicati da un "Utente Anonimo" dopo l\'eliminazione dell\'account',
        "Per la completa eliminazione di tutti i contenuti, devi contattarci direttamente all'indirizzo hurricanesoftwaresolutions@gmail.com",
        'Potremmo continuare a mostrare recensioni anonimizzate per preservare il valore della piattaforma per tutti gli utenti',
      ],
    },
    privacy: {
      title: 'Privacy e Dati',
      content:
        'Prendiamo seriamente la tua privacy. Utilizzando BiteCritic, riconosci che:',
      items: [
        'Raccogliamo ed elaboriamo i tuoi dati come descritto nella nostra Informativa sulla Privacy',
        'Il tuo profilo pubblico e le recensioni sono visibili agli altri utenti',
        'Puoi controllare le tue impostazioni sulla privacy attraverso il tuo account',
        'Utilizziamo cookie e tecnologie simili',
      ],
    },
    community: {
      title: 'Linee Guida della Comunità',
      content: 'Come membro della comunità BiteCritic, accetti di:',
      items: [
        'Trattare gli altri utenti con rispetto',
        'Non molestare o discriminare gli altri',
        'Fornire contributi costruttivi e utili',
        'Segnalare contenuti o comportamenti inappropriati',
      ],
    },
    termination: {
      title: 'Terminazione',
      content: 'BiteCritic si riserva il diritto di:',
      items: [
        'Sospendere o terminare gli account che violano questi termini',
        'Modificare o interrompere i servizi in qualsiasi momento',
        'Rimuovere contenuti che violano queste linee guida',
        'Aggiornare questi termini con un preavviso ragionevole',
        'Anonimizzare i dati degli utenti ma conservare i contenuti quando viene eliminato un account',
        'Elaborare le richieste di eliminazione completa inviate via email entro 30 giorni',
      ],
    },
  },
  agreement: {
    checkbox:
      "Ho letto e accetto i Termini e Condizioni e l'Informativa sulla Privacy di BiteCritic.",
    required: 'Devi accettare i termini e condizioni per continuare.',
    view: 'Visualizza i termini e condizioni completi',
  },
};

export default termsTranslations;
